var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('van-nav-bar',{attrs:{"fixed":"","z-index":"10","placeholder":"","safe-area-inset-top":"","title":_vm.title,"left-text":_vm.isLeft ? _vm.leftText : '',"left-arrow":_vm.isLeft},on:{"click-left":_vm.onClickLeft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }